// 土耳其语
import tr from '../JsonLang/tr.json'
import trSpec from '../JsonLangSpec/tr.json'
export const lang = {
  ...tr, ...trSpec
}
